import axios from "axios";
import apiClient from "./apiClient";
export interface RefundRequest { userId: string; walletId: string; transactionTxRef: string; }
export async function refundWallet(body: RefundRequest) {
  return (await apiClient.post<{ success: boolean; message: string; wallet: { id: string; walletBalance: string } }>("wallets/refund", body)).data;
}
export async function getProviderBalance() {
  return (await apiClient.get<{ balance: string | number | null }>("wallets/mailer-balance")).data;
}
/** Download the receipt for one selected transaction. */
export async function downloadTransactionReceipt(transactionId: string): Promise<Blob> {
  return (await apiClient.get(`transactions/${encodeURIComponent(transactionId)}/pdf`, { responseType: "blob" })).data;
}
export interface ReferralConfig { points: number | string; pointsConversionNGN: number | string; pointsConversionGBP: number | string; }
export async function getReferralConfig(): Promise<ReferralConfig | null> {
  try { return (await apiClient.get<ReferralConfig>("referrals/config")).data; }
  catch (err) { if (axios.isAxiosError(err) && err.response?.status === 404) return null; throw err; }
}
export async function saveReferralConfig(body: { points: number; conversionNGN: number; conversionGBP: number }): Promise<ReferralConfig> {
  return (await apiClient.post<{ data: ReferralConfig }>("referrals/create-point", body)).data.data;
}
export interface PaymentDetails { bankName: string; accountName: string; accountNumber: string; sortCode: string; currency: string; }
export async function getPaymentDetails(): Promise<PaymentDetails | null> {
  try {
    const { bankName, accountName, accountNumber, sortCode, currency } = (await apiClient.get<{ paymentInfo: PaymentDetails }>("payment-details")).data.paymentInfo;
    return { bankName, accountName, accountNumber, sortCode, currency };
  }
  catch (err) { if (axios.isAxiosError(err) && err.response?.status === 404) return null; throw err; }
}
export async function savePaymentDetails(body: PaymentDetails, exists: boolean) {
  const { bankName, accountName, accountNumber, sortCode, currency } = body;
  const payload = { bankName, accountName, accountNumber, sortCode, currency };
  return (await (exists ? apiClient.patch("payment-details/update-details", payload) : apiClient.post("payment-details/create-details", payload))).data;
}
